import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal, ModalBody, Row, Table } from "reactstrap";

import { confirm } from "components/Confirmation";
import ordemServicoService from "services/OrdemServicoService";
import { StatusExecucaoEquipeEnum } from "services/OrdemServicoService";
import comboService from "services/ComboService";
import { GFDateField } from "components/GeneralForm";
import { showLoading } from "components/Loading";
import { hideLoading } from "components/Loading";
import { erroInesperado } from "services/Utils";
import { toast } from "react-toastify";
import "./modalAtribuirEquipeExecucao.scss";

export default function ModalAtribuirEquipeExecucao({ config, onClosed, onChange }) {
  const [idEquipe, setIdEquipe] = useState()
  const [equipes, setEquipes] = useState([])
  const [itensSelecionados, setItensSelecionados] = useState([])
  const [data, setData] = useState({})

  useEffect(() => {
    if (config?.idOrdemServico) {
      comboService.equipes().then(res => {
        if (res.success) {
          setEquipes(res.data)
        }
      })
    } else {
      setEquipes([])
    }
    setData({})
    setIdEquipe()
    setItensSelecionados([])
  }, [config?.idOrdemServico])

  const itensDisponiveis = useMemo(() => config?.itens || [], [config?.itens])

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const execucaoNaoFinalizadaDaEquipe = useMemo(() => {
    if (!idEquipe) return null

    return (config?.execucoes || []).find(ex => ex.idEquipe == idEquipe && ex.status != StatusExecucaoEquipeEnum.FINALIZADA) || null
  }, [config?.execucoes, idEquipe])

  useEffect(() => {
    if (execucaoNaoFinalizadaDaEquipe?.data) {
      setData(data => ({ ...data, previsaoInicio: new Date(execucaoNaoFinalizadaDaEquipe.data) }))
      return
    }

    setData(data => ({ ...data, previsaoInicio: null }))
  }, [execucaoNaoFinalizadaDaEquipe?.data])

  const inicioValido = useMemo(() => {
    if (execucaoNaoFinalizadaDaEquipe)
      return true

    if (!data.previsaoInicio)
      return false

    const hoje = new Date()
    hoje.setHours(0, 0, 0, 0)

    return data.previsaoInicio.getTime() >= hoje.getTime()
  }, [data.previsaoInicio, execucaoNaoFinalizadaDaEquipe])

  const dataExecucao = useMemo(() => {
    if (execucaoNaoFinalizadaDaEquipe?.data)
      return execucaoNaoFinalizadaDaEquipe.data

    return data.previsaoInicio
  }, [data.previsaoInicio, execucaoNaoFinalizadaDaEquipe])

  const handleConfirmar = () => {
    confirm({
      text: 'Você deseja atribuir estes itens para as equipes selecionadas?',
      icon: 'bi-exclamation-triangle',
      onConfirm: async () => {
        showLoading()
        try {
          await ordemServicoService.atribuir(config.idOrdemServico, idEquipe, dataExecucao, itensSelecionados)
          onChange && onChange()
          onClosed && onClosed()
          hideLoading()
        } catch (ex) {
          console.log(ex)
          hideLoading()
          if ([400, 409].includes(ex.status) && ex?.response?.data?.message) {
            toast(ex?.response?.data?.message)
            return
          }
          erroInesperado()
        }
      }
    })
  }

  const handleSelecionarItem = (idItem) => {
    if (itensSelecionados.includes(idItem)) {
      setItensSelecionados(itensSelecionados.filter(id => id !== idItem))
      return
    }

    setItensSelecionados([...itensSelecionados, idItem])
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        {(config) && (
          <>
            <h2>Atribuir Equipe de Execução</h2>
            <hr />
            <Row>
              <GFDateField
                colspan={4}
                label="Data prevista para iniciar"
                name="previsaoInicio"
                data={data}
                onChange={handleChange}
                disabled={!!execucaoNaoFinalizadaDaEquipe}
              />
              <div className="col-8">
                <div className="form-group">
                  <label htmlFor="idEquipe">Equipe</label>
                  <select id="idEquipe" className="form-control" value={idEquipe || ''} onChange={ev => ev.target.value == '' ? setIdEquipe() : setIdEquipe(+ev.target.value)}>
                    <option value="">Selecione</option>
                    {equipes.map(el => (
                      <option key={el.id} value={el.id}>{el.nome}</option>
                    ))}
                  </select>
                </div>
              </div>
            </Row>
            <div className="mt-4">
              <h4>Selecione os itens</h4>
              <Table bordered className="mb-0 tabela-itens-atribuicao">
                <thead className="thead-itens-atribuicao">
                  <tr>
                    <th className="col-checkbox">&nbsp;</th>
                    <th>Item</th>
                  </tr>
                </thead>
                <tbody>
                  {itensDisponiveis.map(it => {
                    const inputId = `item-${it.id}`

                    return (
                      <tr key={it.id}>
                        <td className="text-center align-middle">
                          <input
                            id={inputId}
                            type="checkbox"
                            checked={itensSelecionados.includes(it.id)}
                            onChange={() => handleSelecionarItem(it.id)}
                          />
                        </td>
                        <td className="align-middle">
                          <label htmlFor={inputId} className="mb-0 label-item-atribuicao">
                            {it.codigo} - {it.descricao}
                          </label>
                        </td>
                      </tr>
                    )
                  })}
                  {itensDisponiveis.length == 0 && (
                    <tr>
                      <td colSpan={2}>Nenhum item pendente de atribuição.</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            <div className="row mt-4">
              <div className="col-12 text-right">
                <Button color="primary" onClick={handleConfirmar} disabled={!idEquipe || itensSelecionados.length == 0 || !inicioValido}>Atribuir Itens à Equipe</Button>
                <Button color="primary" onClick={onClosed} outline>Cancelar</Button>
              </div>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  )
}